import R from "ramda";
import { SET_REPORTS } from "actions/reports-actions";

export const initialState = {
  reports: []
};

export const reportsReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_REPORTS:
      return stateForSetReports(state, action);
    default:
      return state;
  }
};

const stateForSetReports = (state, action) => {
  const newReports = action.data.reports.map(report => {
    if (report.name === null || report.name === undefined) {
      return R.set(R.lensProp("name"), "", report);
    }
    return report;
  });
  return R.merge(state, { reports: newReports });
};



// WEBPACK FOOTER //
// ./src/js/reducers/reports-reducer.js